import React from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
// @ts-ignore
import { Comment, Retweet, LikeOutlined } from '@netbasequid/core'
import ActionButton from './ActionButton'
import { useContextMediaDetail } from './context'

const Container = styled.div`
  display: flex;
  gap: 4px;
`

interface TwitterActionsProps {
  postId?: string
}

const TwitterActions = ({ postId: postIdFromProp }: TwitterActionsProps) => {
  const { postId: postIdFromContext } = useContextMediaDetail()
  const postId = postIdFromProp || postIdFromContext
  const { t } = useTranslation()

  return (
    <Container>
      <ActionButton
        url={`https://twitter.com/intent/tweet?in_reply_to=${postId}`}
        IconComponent={Comment}
        tooltipContent={t('reply')}
      />
      <ActionButton
        url={`https://twitter.com/intent/retweet?tweet_id=${postId}`}
        IconComponent={Retweet}
        tooltipContent={t('retweet')}
      />
      <ActionButton
        url={`https://twitter.com/intent/favorite?tweet_id=${postId}`}
        IconComponent={LikeOutlined}
        tooltipContent={t('like')}
      />
    </Container>
  )
}

export default TwitterActions
